import moment from 'moment';
import BaseMitConfigService from './BaseMitConfigService.js';
import BaseMitReserveDateTimeService from './BaseMitReserveDateTimeService.js';
import BaseMitExternalApiService from './BaseMitExternalApiService.js';

const SETUP_STATES = {
    default:{
        name:'None',
        val:null,
        hint:'No setup is requested'
    },
    requested:{
        name:'Requested',
        val:'requested',
        hint:'Setup has been requested'
    },
    completed:{
        name:'Completed',
        val:'completed',
        hint:'Requested setup has been completed'
    },
    contact:{
        name:'Contact TIG',
        val:'contact',
        hint:'Please contact TIG about this setup'
    }
}
        // calendarColorEvent:'grey lighten-1',
        // calendarColorMyEvent:'teal lighten-3',
        // calendarColorMySecondaryEvent:'deep-purple lighten-3',
        // calendarColorPotential:'primary lighten-2',
const CALENDAR_COLORS = {
    event:'blue-grey lighten-3',
    myEvent:'teal lighten-3',
    mySecondaryEvent:'deep-purple lighten-4',
    potentialEvent:'primary lighten-2'
  };

class BaseMitReserveService {

  constructor() {
      this.service = new BaseMitExternalApiService();

      this.serviceDateTime = new BaseMitReserveDateTimeService();
      this.defaultDateFormat = 'YYYY-MM-DD';
      this.defaultTimeFormat = 'hh:mm A';
      this.dateDisplayFormat1 = 'ddd MMM DD YYYY';
      this.dateDisplayFormat2 = 'MMM DD YYYY';
      this.dateTimeDisplayFormat1 = 'ddd MMM DD YYYY hh:mm A';
      this.dateTimeDisplayFormat2 = 'MMM DD YYYY hh:mm A';

      this.defaultDuration = 60;//in minutes

      this.calendarColors = {
        event:'blue-grey lighten-3',
        myEvent:'blue lighten-3',
        mySecondaryEvent:'deep-purple lighten-4',
        potentialEvent:'primary lighten-2',
        
      }
  }

  getCalendarColors() {
    return CALENDAR_COLORS;
  }

  getSetupStateDict() {
    return SETUP_STATES;
  }

  getSetupStateArray(){
    let a = [];
    for (var key in SETUP_STATES) {
        if (SETUP_STATES.hasOwnProperty(key)) {
            a.push(SETUP_STATES[key])
        }
    }
    return a;
  }
  
  getSetupStateFromValue(val){
    if(SETUP_STATES.hasOwnProperty(val))
        return SETUP_STATES[val]
    else
        return SETUP_STATES.default; //also null or no request
  }

  setSetupValueDescriptionChanged(reservation){
    if(reservation.setupDescription && reservation.setupDescription.length > 0){
        reservation.setupState = SETUP_STATES.requested.val;
        reservation.setupStateDisplay = this.getSetupStateFromValue(SETUP_STATES.requested.val);
    }
    else{
        reservation.setupState = SETUP_STATES.default.val;
        reservation.setupStateDisplay = this.getSetupStateFromValue(SETUP_STATES.default.val);
    }
    
  }
  hasEditRights(reservation, csailId){
    return this.isOwner(reservation, csailId) || this.isSecondaryOwner(reservation, csailId);
  }
  isOwner(reservation, csailId){
    return csailId === reservation.owner;
  }
  isSecondaryOwner(reservation, csailId){
    return reservation.secondaryOwners.indexOf(csailId)  > -1;
  }

  isRecurring(reservation){
    if(reservation.recurring && reservation.recurring.repeatChoice){
        return true;
    }
    return false;
  }

  repeatOptions(){
    return [
        {text:"Doesn't Repeat",value:null},
        // {text:'Daily',value:'daily'},
        {text:'Weekly',value:'weekly'},
        {text:'Monthly',value:'monthly'}
    ]
  }
  setToDefaultDateTime(reservation, dateFormat, timeFormat){
        dateFormat = dateFormat || this.defaultDateFormat;
        timeFormat = timeFormat || this.defaultTimeFormat;

        let startTime = moment();

        let defaultTimes = this.serviceDateTime.getDefaultTimes(this.serviceDateTime.getTimes(), this.defaultDuration, true);
        reservation.startDate = defaultTimes.start.format(dateFormat);
        reservation.startTime = defaultTimes.start.format(timeFormat);
        reservation.duration = this.defaultDuration;
        reservation.allDay = false;

        this.updateDateTime(reservation, dateFormat, timeFormat);
  }

  create(startTime, duration, dateFormat, timeFormat){
      dateFormat = dateFormat || this.defaultDateFormat;
      timeFormat = timeFormat || this.defaultTimeFormat;

      startTime = startTime || moment();
      duration = duration || this.defaultDuration;//in minutes

      let defaultTimes = this.serviceDateTime.getDefaultTimes(this.serviceDateTime.getTimes(), duration, true);

      let model = {
          id:null,
          mitId:null,
          uniqueId:null,
          allDay:false,
          startDateTime:defaultTimes.start,
          startDate:defaultTimes.start.format(dateFormat),
          startTime:defaultTimes.start.format(timeFormat),
          endDateTime:defaultTimes.end,
          endDate:defaultTimes.end.format(dateFormat),
          endTime:defaultTimes.end.format(timeFormat),
          duration: duration,
          setupState:null,
          setupStateDisplay:this.getSetupStateFromValue(null),
          setupDescription:'',
          data:{},
          description:'',
          name:'',
          owner:null,
          secondaryOwners:[],
          recurring:{
            repeatsUntilDate: moment(defaultTimes.start).add(1,'year'),
            repeatsUntilDateString: moment(defaultTimes.start).add(1,'year').format(dateFormat),
            repeatChoice:null,
            events:[],
            conflictsIgnored:[],
            monthlyOnDate:true,
            weeklyInterval:1,
            days:{
                monday:false,
                tuesday:false,
                wednesday:false,
                thursday:false,
                friday:false,
                saturday:false,
                sunday:false
            }
        }
      }

      this.addDisplayDates(model);

      return model;
  }

  copy(reservation){
    let model = {
        id:reservation.id,
        mitId:reservation.mitId,
        uniqueId:reservation.uniqueId,
        allDay:reservation.allDay,
        startDateTime:moment(reservation.startDateTime),
        startDate:reservation.startDate,
        startTime:reservation.startTime,
        endDateTime:moment(reservation.endDateTime),
        endDate:reservation.endDate,
        endTime:reservation.endTime,
        duration: reservation.duration,
        data:{
            externalId:(reservation.data && reservation.data.externalId) ? reservation.data.externalId : null,
            externalSeriesId:(reservation.data && reservation.data.externalSeriesId) ? reservation.data.externalSeriesId : null
        },
        owner:reservation.owner,
        setupState:reservation.setupState,
        setupStateDisplay:this.getSetupStateFromValue(reservation.setupState),
        setupDescription:reservation.setupDescription,
        description:reservation.description,
        name:reservation.name,
        secondaryOwners:reservation.secondaryOwners.map((x) => x) //make a shallow copy so we don't change the original
    };

    if(reservation.recurring){
        model.recurring = {
            repeatsUntilDate: moment(reservation.recurring.repeatsUntilDate),
            repeatsUntilDateString:reservation.recurring.repeatsUntilDateString,
            repeatChoice:reservation.recurring.repeatChoice,
            events:reservation.recurring.events.map((x) => x), //make a shallow copy so we don't change the original
            conflictsIgnored:reservation.recurring.conflictsIgnored.map((x) => x), //make a shallow copy so we don't change the original
            monthlyOnDate:reservation.recurring.monthlyOnDate,
            weeklyInterval:reservation.recurring.weeklyInterval,
            days:{
                monday:reservation.recurring.days.monday,
                tuesday:reservation.recurring.days.tuesday,
                wednesday:reservation.recurring.days.wednesday,
                thursday:reservation.recurring.days.thursday,
                friday:reservation.recurring.days.friday,
                saturday:reservation.recurring.days.saturday,
                sunday:reservation.recurring.days.sunday
            }
        }
    }

    this.addDisplayDates(model);

    return model;
  }

  addDisplayDates(reservation){
    reservation.startDateDisplay1 = reservation.startDateTime.format(this.dateDisplayFormat1);
    reservation.startDateDisplay2 = reservation.startDateTime.format(this.dateDisplayFormat2);
    reservation.startDateTimeDisplay1 = reservation.startDateTime.format(this.dateTimeDisplayFormat1);
    reservation.startDateTimeDisplay2 = reservation.startDateTime.format(this.dateTimeDisplayFormat2);
    reservation.startTime1 = reservation.startDateTime.minute() === 0 ? reservation.startDateTime.format('h a'):reservation.startDateTime.format('h:mm a');

    reservation.endDateDisplay1 = reservation.endDateTime.format(this.dateDisplayFormat1);
    reservation.endDateDisplay2 = reservation.endDateTime.format(this.dateDisplayFormat2);
    reservation.endDateTimeDisplay1 = reservation.endDateTime.format(this.dateTimeDisplayFormat1);
    reservation.endDateTimeDisplay2 = reservation.endDateTime.format(this.dateTimeDisplayFormat2);
    reservation.endTime1 = reservation.endDateTime.minute() === 0 ? reservation.endDateTime.format('h a'):reservation.endDateTime.format('h:mm a');

    reservation.durationDisplay1 = reservation.endDateTime.from(reservation.startDateTime, true)

    if(reservation.recurring){
        reservation.recurring.repeatsUntilDateDisplay1 = reservation.recurring.repeatsUntilDate.format(this.dateDisplayFormat1);
        reservation.recurring.repeatsUntilDateDisplay2 = reservation.recurring.repeatsUntilDate.format(this.dateDisplayFormat2);
        reservation.recurring.repeatsUntilDateTimeDisplay1 = reservation.recurring.repeatsUntilDate.format(this.dateTimeDisplayFormat1);
        reservation.recurring.repeatsUntilDateTimeDisplay2 = reservation.recurring.repeatsUntilDate.format(this.dateTimeDisplayFormat2);
    }
    
  }

  generateRecurringEvents(reservation){
        let allReservations = [];

        if(reservation.recurring.repeatChoice === null){
            //just evaluate the single date, we have not got to the repeating portion yet!
            //eval from start to start, so just today
            allReservations = this.serviceDateTime.generateRecurringDates(reservation.startDateTime, reservation.startDateTime, reservation.duration, 1, 'day');
        }
        else if(reservation.recurring.repeatChoice === 'weekly'){
            //eval from start to end, for selected days
            for (var prop in reservation.recurring.days) {
                if (reservation.recurring.days[prop]) {
                    let tempStart = new moment(reservation.startDateTime);//this date will be manipulated each iteration, so create a new instance.
                    //repeat for each day selected
                    let weekDayToFind = moment().day(prop).weekday(); //change to searched day name

                    while (tempStart.weekday() !== weekDayToFind){
                        tempStart.add(1, 'day');
                    }
                    allReservations = this.serviceDateTime.generateRecurringDates(tempStart, reservation.recurring.repeatsUntilDate, reservation.duration, reservation.recurring.weeklyInterval, 'week').concat(allReservations);
                }
            }
            //IF the user has deselected all the days, treat it as a single day
            if(allReservations.length <= 0){
              allReservations = this.serviceDateTime.generateRecurringDates(reservation.startDateTime, reservation.startDateTime, reservation.duration, 1, 'day');
          }

        }
        else if(reservation.recurring.repeatChoice === 'monthly'){
            //eval from start to end, so all days
            allReservations = this.serviceDateTime.generateRecurringDates(reservation.startDateTime, reservation.recurring.repeatsUntilDate, reservation.duration, 1, 'month');
        }
        else{
            //eval from start to end, so all days
            allReservations = this.serviceDateTime.generateRecurringDates(reservation.startDateTime, reservation.recurring.repeatsUntilDate, reservation.duration, 1, 'year');
        }

        return allReservations;
  }

  updateRecurrinEndDateDefault(reservation, dateFormat){
    dateFormat = dateFormat || this.defaultDateFormat;

    if(this.isRecurring(reservation)){
        //Set to end of day is important. We want to make sure we are generating events
        //up to and including this full day.
        let date = moment(reservation.startDateTime).add(1,'year').endOf('day');
        reservation.recurring.repeatsUntilDate = date;
        reservation.recurring.repeatsUntilDateString = date.format(dateFormat);
    
        this.addDisplayDates(reservation);
    }
    
    return reservation;
  }
  updateRecurrinEndDate(reservation, dateFormat){
    dateFormat = dateFormat || this.defaultDateFormat;

    if(this.isRecurring(reservation)){
        //Set to end of day is important. We want to make sure we are generating events
        //up to and including this full day.
        let date = moment(reservation.recurring.repeatsUntilDateString, dateFormat).endOf('day');

        reservation.recurring.repeatsUntilDate = date;
        reservation.recurring.repeatsUntilDateString = date.format(dateFormat);
    
        this.addDisplayDates(reservation);
    }
    
    return reservation;
  }

  updateDateTime(reservation, dateFormat, timeFormat){
    dateFormat = dateFormat || this.defaultDateFormat;
    timeFormat = timeFormat || this.defaultTimeFormat;

    let dateStart;
    let timeStart;
    let dateEnd;

    if(reservation.allDay){
        //**** All DAY
        dateStart = moment(reservation.startDate, dateFormat).startOf('day');
        dateEnd = moment(reservation.startDate, dateFormat).endOf('day');
    }
    else{
        //******Specific Time
        dateStart = moment(reservation.startDate, dateFormat);
        timeStart = moment(reservation.startTime, timeFormat);

        dateStart.set({
            hour:   timeStart.get('hour'),
            minute: timeStart.get('minute'),
            second: timeStart.get('second')
        });
    
        dateEnd = new moment(dateStart).add(reservation.duration,'m');//add the duration in minutes to the start to get the new end date and time.
    }

    reservation.startDateTime = dateStart;
    reservation.startDate = dateStart.format(dateFormat);
    reservation.startTime = dateStart.format(timeFormat);

    reservation.endDateTime = dateEnd;
    reservation.endDate = dateEnd.format(dateFormat);
    reservation.endTime = dateEnd.format(timeFormat);

    this.addDisplayDates(reservation);

    this.updateRecurrinEndDate(reservation);

    return reservation;
  }

  convertAPIToUI(reservationModelAPI, dateFormat, timeFormat){
    dateFormat = dateFormat || this.defaultDateFormat;
    timeFormat = timeFormat || this.defaultTimeFormat;

    //nothing to convert if there is no response
    //This can happen currently if the user doesn't have access to the reservation
    //or if the reservation has been deleted
    if(typeof reservationModelAPI === 'undefined' || reservationModelAPI === null){
        return null;
    }

      let allDay = false;
      let currentTime = moment().local();

      reservationModelAPI.startTime = moment(reservationModelAPI.startTime).local();
      reservationModelAPI.endTime = moment(reservationModelAPI.endTime).local();

      if(moment.duration(reservationModelAPI.endTime.diff(reservationModelAPI.startTime)).asMinutes() >= 1439){
          allDay = true;
      }

      let model = {
        id:reservationModelAPI.id,
        mitId:reservationModelAPI.mitId,
        uniqueId:reservationModelAPI.uniqueId,
        recurringId:reservationModelAPI.recurringId,
        recurringUniqueId:reservationModelAPI.recurringUniqueId,
        allDay:allDay,
        startDateTime:reservationModelAPI.startTime,
        startDate:reservationModelAPI.startTime.format(dateFormat),
        startTime:reservationModelAPI.startTime.format(timeFormat),
        endDate:reservationModelAPI.endTime.format(dateFormat),
        endTime:reservationModelAPI.endTime.format(timeFormat),
        endDateTime:reservationModelAPI.endTime,
        data:reservationModelAPI.data,
        duration: moment.duration(reservationModelAPI.endTime.diff(reservationModelAPI.startTime)).asMinutes(),
        setupState:reservationModelAPI.setupState,
        setupStateDisplay:this.getSetupStateFromValue(reservationModelAPI.setupState),
        setupDescription:reservationModelAPI.setupDescription,
        description:reservationModelAPI.description,
        name:reservationModelAPI.name,
        owner:reservationModelAPI.owner,
        secondaryOwners: (reservationModelAPI.secondaryOwners) ? reservationModelAPI.secondaryOwners.map((x) => x) : [],
        expired: (reservationModelAPI.startTime < currentTime) ? true : false
      };

      if(reservationModelAPI.recurring){
        reservationModelAPI.recurring.repeatsUntilDate = moment(reservationModelAPI.recurring.repeatsUntilDate).local();

        let conflictsIgnored = reservationModelAPI.recurring.conflictsIgnored || [];
        let ignoredListLocal = [];
        for(let x = 0; x < conflictsIgnored.length; x++){
            ignoredListLocal.push({
              startTime:moment(conflictsIgnored[x][0]).local(),
              endTime:moment(conflictsIgnored[x][1]).local()
            })
          }

        model.recurring = {
                repeatsUntilDate: reservationModelAPI.recurring.repeatsUntilDate,
                repeatsUntilDateString:reservationModelAPI.recurring.repeatsUntilDate.format(dateFormat),
                repeatChoice:reservationModelAPI.recurring.repeatChoice,
                events:[], //leave empty, if use edits this we will need to wipe out existing and recreate from scratch
                conflictsIgnored:ignoredListLocal,
                monthlyOnDate:reservationModelAPI.recurring.monthlyOnDate,
                weeklyInterval:reservationModelAPI.recurring.weeklyInterval,
                days:{
                    monday:reservationModelAPI.recurring.days.monday,
                    tuesday:reservationModelAPI.recurring.days.tuesday,
                    wednesday:reservationModelAPI.recurring.days.wednesday,
                    thursday:reservationModelAPI.recurring.days.thursday,
                    friday:reservationModelAPI.recurring.days.friday,
                    saturday:reservationModelAPI.recurring.days.saturday,
                    sunday:reservationModelAPI.recurring.days.sunday
                }
        }
        
      }
      
      this.addDisplayDates(model);

      return model;
  }
  convertUIToAPI(reservationModelUI){
        let model = {
            id:reservationModelUI.id,
            mitId:reservationModelUI.mitId,
            uniqueId:reservationModelUI.uniqueId,
            startTime:reservationModelUI.startDateTime.utc().format("YYYY-MM-DD hh:mm A"),
            endTime:reservationModelUI.endDateTime.utc().format("YYYY-MM-DD hh:mm A"),
            data:reservationModelUI.data,
            description:reservationModelUI.description,
            setupState:reservationModelUI.setupState,
            setupDescription:reservationModelUI.setupDescription,
            name:reservationModelUI.name,
            secondaryOwners:reservationModelUI.secondaryOwners.map((x) => x),
        }

        if(reservationModelUI.recurring){
            model.recurring = {
                repeatsUntilDate: reservationModelUI.recurring.repeatsUntilDate.utc().format("YYYY-MM-DD hh:mm A"),
                repeatChoice:reservationModelUI.recurring.repeatChoice,
                events:this.serviceDateTime.convertRecurringDatesListToUTCString(reservationModelUI.recurring.events),//reservationModelUI.recurring.events.map((x) => x), //make a shallow copy so we don't change the original
                conflictsIgnored:this.serviceDateTime.convertRecurringDatesListToUTCString(reservationModelUI.recurring.conflictsIgnored),//eservationModelUI.recurring.conflictsIgnored.map((x) => x), //make a shallow copy so we don't change the original
                monthlyOnDate:reservationModelUI.recurring.monthlyOnDate,
                weeklyInterval:reservationModelUI.recurring.weeklyInterval,
                days:{
                    monday:reservationModelUI.recurring.days.monday,
                    tuesday:reservationModelUI.recurring.days.tuesday,
                    wednesday:reservationModelUI.recurring.days.wednesday,
                    thursday:reservationModelUI.recurring.days.thursday,
                    friday:reservationModelUI.recurring.days.friday,
                    saturday:reservationModelUI.recurring.days.saturday,
                    sunday:reservationModelUI.recurring.days.sunday
                }
            }
        }

    return model;
  }

  save(reservationUIModel){

    let r = this.convertUIToAPI(reservationUIModel);

    return new Promise ((resolve, reject) => {
        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('POST', reserveUrl, '/api/v1/user/reservations',r)
           .then((response) => {
               return resolve(response);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}

saveManager(reservationUIModel){

    let r = this.convertUIToAPI(reservationUIModel);

    return new Promise ((resolve, reject) => {
        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('POST', reserveUrl, '/api/v1/manager/reservations',r)
           .then((response) => {
               return resolve(response);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}

deleteManager(uniqueId){
    //Backend will only allow this if the user is the owner or secondary owner
    return new Promise ((resolve, reject) => {
        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('DELETE', reserveUrl, '/api/v1/manager/reservations/'+uniqueId)
           .then((response) => {
              return resolve(response);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}

delete(uniqueId){
    //Backend will only allow this if the user is the owner or secondary owner
    return new Promise ((resolve, reject) => {
        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('DELETE', reserveUrl, '/api/v1/user/reservations/'+uniqueId)
           .then((response) => {
              return resolve(response);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}

getManagerRecurringChildren(recurringUniqueId){

    return new Promise ((resolve, reject) => {
        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('GET', reserveUrl, '/api/v1/manager/reservations/'+recurringUniqueId+'/children')
           .then((response) => {
                for(let x = 0; x < response.reservations.length; x++){
                    response.reservations[x] = this.convertAPIToUI(response.reservations[x]);
                }
               return resolve(response);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}

getManagerGroupedReservations(paging, options){
    return new Promise ((resolve, reject) => {
        let url = new URL(window.location.origin+'/api/v1/manager/reservations/grouped');

        for (let prop in options) {
            if (options.hasOwnProperty(prop)) {
                url.searchParams.append(prop, options[prop]);
            }
        }
        for (let prop in paging) {
            if (paging.hasOwnProperty(prop)) {
                url.searchParams.append(prop, paging[prop]);
            }
        }
        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('GET', reserveUrl, url.pathname+url.search)
            .then((response) => {
            
                for(let x = 0; x < response.reservations.length; x++){
                    response.reservations[x] = this.convertAPIToUI(response.reservations[x]);
                }

                return resolve(response);
            })
            .catch((error) => {
                console.log('ERROR:', error);
                return reject(error);
            });
    });
}

getAllActiveReservations(mitIds, startUTC, endUTC, excludeUniqueIds){
    startUTC = startUTC || moment().startOf('day').utc().format('YYYY-MM-DD hh:mm A');
    endUTC = endUTC || moment().endOf('day').utc().format('YYYY-MM-DD hh:mm A');

    return new Promise ((resolve, reject) => {

        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('GET', reserveUrl,'/api/v1/user/reservations/?mitIds='+mitIds+'&startUTC='+startUTC+'&endUTC='+endUTC+'&excludeUniqueIds='+excludeUniqueIds)
           .then((response) => {
                for(let x = 0; x < response.reservations.length; x++){
                    response.reservations[x] = this.convertAPIToUI(response.reservations[x]);
                }

                return resolve(response);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}

getExistingReservationsBySpace(mitIds, startUTC, endUTC, excludeUniqueIds){
    startUTC = startUTC || moment().startOf('day').utc().format('YYYY-MM-DD hh:mm A');
    endUTC = endUTC || moment().endOf('day').utc().format('YYYY-MM-DD hh:mm A');

    return new Promise ((resolve, reject) => {

        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('GET', reserveUrl,'/api/v1/user/reservations/?mitIds='+mitIds+'&startUTC='+startUTC+'&endUTC='+endUTC+'&excludeUniqueIds='+excludeUniqueIds)
           .then((response) => {
                for(let x = 0; x < response.reservations.length; x++){
                    response.reservations[x] = this.convertAPIToUI(response.reservations[x]);
                }

                return resolve(response);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}
getExistingReservations(startUTC, endUTC){
    startUTC = startUTC || moment().startOf('day').utc().format('YYYY-MM-DD hh:mm A');
    endUTC = endUTC || moment().endOf('day').utc().format('YYYY-MM-DD hh:mm A');

    return new Promise ((resolve, reject) => {
        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('GET', reserveUrl,'/api/v1/user/reservations?startUTC='+startUTC+'&endUTC='+endUTC)
           .then((response) => {
                for(let x = 0; x < response.reservations.length; x++){
                    response.reservations[x] = this.convertAPIToUI(response.reservations[x]);
                }

                return resolve(response);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}
getReservationByUniqueId(uniqueId){
    return new Promise ((resolve, reject) => {
        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('GET', reserveUrl,'/api/v1/manager/reservations/reservation/'+uniqueId)
           .then((response) => {
                let data = this.convertAPIToUI(response.reservations[0]);

                return resolve(data);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}

getMyReservationByUniqueId(uniqueId){
    return new Promise ((resolve, reject) => {
        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('GET',reserveUrl,'/api/v1/user/reservations/my/'+uniqueId)
           .then((response) => {
                let data = this.convertAPIToUI(response.reservations[0]);

                return resolve(data);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}

organizeMyReservations(reservations, userCsailId){
    let myReservationModel = {
        asOwner:[],
        asSecondaryOwner:[],
        all:[]
    };

    for(let x = 0; x < reservations.length; x++){
        if(reservations[x].owner === userCsailId){
            myReservationModel.asOwner.push(reservations[x]);
        }
        else{
            myReservationModel.asSecondaryOwner.push(reservations[x]);
        }
        myReservationModel.all.push(reservations[x]);
    }

    return myReservationModel;
}

getMyReservations(userCsailId, daterange){
    return new Promise ((resolve, reject) => {
        let url = new URL(window.location.origin+'/api/v1/user/reservations/my');

        if(daterange){
            url.searchParams.append('startUTC', this.serviceDateTime.convertLocalTimeToUTCServerFormat(daterange.start));
            url.searchParams.append('endUTC', this.serviceDateTime.convertLocalTimeToUTCServerFormat(daterange.end))
        }

        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('GET', reserveUrl, url.pathname+url.search)
           .then((response) => {
            for(let x = 0; x < response.reservations.length; x++){
                response.reservations[x] = this.convertAPIToUI(response.reservations[x]);
            }
              
            let myReservations = this.organizeMyReservations(response.reservations, userCsailId);
              

              return resolve(myReservations);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}

getMyReservationsRecurringGrouped(userCsailId){
    return new Promise ((resolve, reject) => {
        let reserveUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('GET', reserveUrl,'/api/v1/user/reservations/my/grouped')
           .then((response) => {
            for(let x = 0; x < response.reservations.length; x++){
                response.reservations[x] = this.convertAPIToUI(response.reservations[x]);
            }
      
            let myReservations = this.organizeMyReservations(response.reservations, userCsailId);
              
              return resolve(myReservations);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
}



}
export default new BaseMitReserveService();
